/* eslint-disable camelcase */
/**
 * Voucherset model
 * @param {number} id - ID
 * @param {string} name - voucher list name
 * @param {number} total_code - total of vouchers
 * @param {array} codes - list of vouchers codes
 */
export default class Voucherset {
	constructor({
		id,
		name,
		total_code,
		vouchers,
	} = {}) {
		this._id = id;
		this._name = name;
		this._total_code = total_code;
		this._vouchers = vouchers || [];
	}

	getKey() {
		return String(this._id);
	}

	getName() {
		return this._name;
	}

	getTotalCode() {
		return this._total_code;
	}

	getCodes() {
		return this._vouchers;
	}
}
